import type { IconProps } from './types';

export const SortAlphabeticalIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 16, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M10.5893 13.3333L13.2559 5H14.5893L17.2559 13.3333M11.4782 10.6339H16.367M0.589264 14.5833L3.9226 17.9167L7.25593 14.5833M3.9226 17.9167V0"
        stroke="#A4A7AE"
        stroke-width="1.66667"
      />
    </svg>
  );
};
